<template>
  <div class="content conta">
    <h1><span><i class="fas fa-user-circle"></i> Relatório de migração de progresso de usuários</span></h1>

    <template v-if="resultadoImportacao">
      <p class="text-right mt-3" v-if="resultadoImportacao.total_processados && resultadoImportacao.total_processados === resultadoImportacao.total">
        Processamento concluído! Total de registros: <strong>{{ resultadoImportacao.total_processados }}</strong>
      </p>
      <p class="text-right mt-3" v-else>
        <i class="fas fa-spinner fa-spin"></i> Processamento em andamento... Registro <strong>{{ resultadoImportacao.total_processados }}</strong> de <strong>{{ resultadoImportacao.total }}</strong>
      </p>
      <div class="table-responsive tabela-resultado-importacao mt-5" v-if="resultadoImportacao.resultado.length">
        <table class="table" ref="resultadoTabelaUsuarios">
          <tr>
            <th>#</th>
            <th>Usuário</th>
            <th>Situação</th>
            <th>Descrição</th>
          </tr>
          <tr v-for="(item, index) in items">
            <td>{{ index + 1}}</td>
            <td>{{ item.usuario }}</td>
            <td>{{ item.status ? 'Sucesso' : 'Erro' }}</td>
            <td>{{ item.descricao }}</td>
          </tr>
        </table>
      </div>
    </template>
    <template v-else>
      <p class="text-right mt-3" v-html="mensagemStatusImportacao"></p>
    </template>

  </div>
</template>

<script>
import UsuarioAPI from '@/api/usuario-api'

export default {
  name: 'ResultadoMigracaoProgressoUsuariosView',
  data () {
    return {
      resultadoImportacao: null,
      resultadoAnterior: true,
      mensagemStatusImportacao: '<i class="fas fa-spinner fa-spin"></i> Obtendo status da importação...'
    }
  },

  mounted () {
    const statusImportacao = window.setInterval(() => {
      if (this.resultadoAnterior) {
        this.resultadoAnterior = false
        UsuarioAPI.obterStatusMigracaoProgressoUsuarios().then(data => {
          this.resultadoAnterior = true

          this.resultadoImportacao = data
          this.items = data.resultado

          if (this.resultadoImportacao.total_processados && this.resultadoImportacao.total && this.resultadoImportacao.total_processados === this.resultadoImportacao.total) {
            clearInterval(statusImportacao)
          }
        }).catch(() => {
          this.mensagemStatusImportacao = '<i class="fas fa-exclamation-triangle"></i> Nenhum status da importação disponível.'
          clearInterval(statusImportacao)
        })
      }
    }, 3000)
  }
}
</script>

<style scoped>

</style>
